import {
    SET_WEEK_COUNT,
    SET_WEEK_START,
    GET_USERS,
    SET_CLICKED_EVENT_SEGMENT,
    SET_SELECTED_AREA,
    SET_SELECTED_DEPARTMENT,
    SET_JOBPOSTING_DATES,
    SET_ARRANGED_JOBPOSTINGS,
    SET_TRACK_ID,
    SET_SELECTED_JOBPOSTING_ID,
    GET_ROSTER_IS_LOCKED,
    SET_ROSTER_IS_LOCKED,
    SET_COPY_PASTE_EVENT,
    GET_PLANNER_DETAILS,
    GET_DEPARTMENTS,
    GET_AREAS,
    GET_EQUIPMENT,
    GET_VEHICLES,
    SET_PLANNER_DETAILS,
    REMOVE_PLANNER_DETAILS,
} from "./types";

import moment from "moment";
import {
    selectPreviousWeekStart,
    selectNextWeekStart,
    selectArrangedJobpostingsFromRawJobpostings,
    selectClickedEventSegment,
    selectWeekCount,
    selectArrangedJobpostingsFromStore,
    selectWeekStart,
} from "./selectors";
import { push } from "connected-react-router";
import firebase from "firebase/app";
import "firebase/database";
import { get } from "lodash";

export const setWeekCount = (weekCount = false) => {
    return (dispatch, getStore) => {
        if (!weekCount) return;

        const store = getStore();
        let weekStart = selectWeekStart(store);
        const weekStartString = moment(weekStart)
            .format("DD-MM-YYYY")
            .toString();
        dispatch(push(`/week-planner-v2/date/${weekStartString}/${weekCount}`));
        dispatch({ type: SET_WEEK_COUNT, payload: weekCount });
    };
};

export const incrementWeekStart = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let weekStart = selectNextWeekStart(store);
        const weekCount = selectWeekCount(store);
        const weekStartString = moment(weekStart)
            .format("DD-MM-YYYY")
            .toString();

        dispatch(push(`/week-planner-v2/date/${weekStartString}/${weekCount}`));
        dispatch({ type: SET_WEEK_START, payload: weekStart });
        dispatch(setArrangedJobpostings());
    };
};
export const setCurrTrackID = (track_id) => {
    return (dispatch) => {
        dispatch({ type: SET_TRACK_ID, payload: track_id });
    };
};
export const setCopyPasteEvent = (event = false) => {
    return (dispatch) => {
        dispatch({ type: SET_COPY_PASTE_EVENT, payload: event });
    };
};
export const setAreaFilter = (area = "all_areas") => {
    return (dispatch) => {
        dispatch({ type: SET_SELECTED_AREA, payload: area });
    };
};
export const setDepartmentFilter = (dep = "all_departments") => {
    return (dispatch) => {
        dispatch({ type: SET_SELECTED_DEPARTMENT, payload: dep });
    };
};
export const initialise = (startDate = false, weekCount = false) => {
    return (dispatch) => {
        if (startDate === false) {
            startDate = moment().startOf("isoWeek").toDate();
        } else {
            startDate = moment(startDate, "DD-MM-YYYY").toDate();
        }

        if (weekCount === false) {
            weekCount = 1;
        }

        dispatch({ type: SET_WEEK_START, payload: startDate });
        dispatch({ type: SET_WEEK_COUNT, payload: parseInt(weekCount) });
        dispatch(setArrangedJobpostings());
    };
};

export const decrementWeekStart = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let weekStart = selectPreviousWeekStart(store);
        const weekCount = selectWeekCount(store);
        const weekStartString = moment(weekStart)
            .format("DD-MM-YYYY")
            .toString();
        dispatch(push(`/week-planner-v2/date/${weekStartString}/${weekCount}`));
        dispatch({ type: SET_WEEK_START, payload: weekStart });
        dispatch(setArrangedJobpostings());
    };
};

export const getUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_USERS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_USERS.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/users`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_USERS.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
            }
        });
    };
};

export const getVehicles = () => {
    return (dispatch) => {
        dispatch({ type: GET_VEHICLES.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_VEHICLES.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/machines`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_VEHICLES.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
            }
        });
    };
};
export const getEquipment = () => {
    return (dispatch) => {
        dispatch({ type: GET_EQUIPMENT.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_EQUIPMENT.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/equipment`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_EQUIPMENT.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
            }
        });
    };
};
export const getDepartments = () => {
    return (dispatch) => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_DEPARTMENTS.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/collections/departments`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_DEPARTMENTS.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
            }
        });
    };
};

export const getAreas = () => {
    return (dispatch) => {
        dispatch({ type: GET_AREAS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_AREAS.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/collections/areas`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_AREAS.SUCCESS,
                            payload: snapshot.val(),
                        });
                    });
            }
        });
    };
};
export const getPlannerInfo = () => {
    return (dispatch) => {
        dispatch({ type: GET_PLANNER_DETAILS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_PLANNER_DETAILS.FAIL,
                });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/week_planner`)
                    .on("value", (snapshot) => {
                        dispatch({
                            type: GET_PLANNER_DETAILS.SUCCESS,
                            payload: snapshot.val(),
                        });
                        dispatch(setArrangedJobpostings());
                    });
            }
        });
    };
};
export const setTrack = (track = false) => {
    return (dispatch) => {
        dispatch({ type: SET_PLANNER_DETAILS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: SET_PLANNER_DETAILS.FAIL,
                });
            } else {
                if (track) {
                    firebase
                        .database()
                        .ref(`/subjects/week_planner/tracks/${track.track_id}`)
                        .update(track);
                    dispatch({
                        type: SET_PLANNER_DETAILS.SUCCESS,
                    });
                } else {
                    dispatch({
                        type: SET_PLANNER_DETAILS.FAIL,
                    });
                }
            }
        });
    };
};
export const setEvent = (event = false) => {
    return (dispatch) => {
        dispatch({ type: SET_PLANNER_DETAILS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: SET_PLANNER_DETAILS.FAIL,
                });
            } else {
                if (event) {
                    firebase
                        .database()
                        .ref(`/subjects/week_planner/events/${event.event_id}`)
                        .update(event);
                    dispatch({
                        type: SET_PLANNER_DETAILS.SUCCESS,
                    });
                } else {
                    dispatch({
                        type: SET_PLANNER_DETAILS.FAIL,
                    });
                }
            }
        });
    };
};
export const pasteEvent = (
    trackID = false,
    event = false,
    department,
    area
) => {
    return (dispatch) => {
        dispatch({ type: SET_PLANNER_DETAILS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: SET_PLANNER_DETAILS.FAIL,
                });
            } else {
                if (trackID && event) {
                    event.event_id = Date.now().toString();
                    event.timestamp = moment().format("DD-MM-YYYY HH:mm:ss");
                    event.department = department;
                    event.area = area;
                    event.job_id = "";
                    event.track_id = trackID;
                    firebase
                        .database()
                        .ref(`/subjects/week_planner/events/${event.event_id}`)
                        .update(event);
                    dispatch({
                        type: SET_PLANNER_DETAILS.SUCCESS,
                    });
                } else {
                    dispatch({
                        type: SET_PLANNER_DETAILS.FAIL,
                    });
                }
            }
        });
    };
};
export const removeTrack = (track_id = false) => {
    return (dispatch) => {
        dispatch({ type: REMOVE_PLANNER_DETAILS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: REMOVE_PLANNER_DETAILS.FAIL,
                });
            } else {
                if (track_id) {
                    firebase
                        .database()
                        .ref(`/subjects/week_planner/tracks/${track_id}`)
                        .remove();
                    dispatch({
                        type: REMOVE_PLANNER_DETAILS.SUCCESS,
                    });
                }
            }
        });
    };
};
export const removeEvent = (event_id = false) => {
    return (dispatch) => {
        dispatch({ type: REMOVE_PLANNER_DETAILS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: REMOVE_PLANNER_DETAILS.FAIL,
                });
            } else {
                if (event_id) {
                    firebase
                        .database()
                        .ref(`/subjects/week_planner/events/${event_id}`)
                        .remove()
                        .then(() => {
                            dispatch(setArrangedJobpostings());
                        });

                    dispatch({
                        type: REMOVE_PLANNER_DETAILS.SUCCESS,
                    });
                }
            }
        });
    };
};
export const setArrangedJobpostings = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        const arrangedJobpostings = selectArrangedJobpostingsFromRawJobpostings(
            store
        );
        dispatch({
            type: SET_ARRANGED_JOBPOSTINGS,
            payload: arrangedJobpostings,
        });
    };
};

export const setClickedEventSegment = (segment) => {
    return (dispatch) => {
        dispatch({
            type: SET_CLICKED_EVENT_SEGMENT,
            payload: JSON.parse(JSON.stringify(segment)),
        });
    };
};

export const setJobpostingDates = (
    jobpostingID,
    startDate = false,
    endDate = false
) => {
    return (dispatch) => {
        let updateObject = {};

        dispatch({
            type: SET_JOBPOSTING_DATES.REQUEST,
        });
        if (startDate !== false) {
            updateObject = { ...updateObject, start_date: startDate };
        }
        if (endDate !== false) {
            updateObject = { ...updateObject, end_date: endDate };
        }

        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: SET_JOBPOSTING_DATES.FAIL,
                });
            } else {
                try {
                    firebase
                        .database()
                        .ref(`/subjects/week_planner/events/${jobpostingID}`)
                        .update(updateObject);
                    dispatch({
                        type: SET_JOBPOSTING_DATES.SUCCESS,
                    });
                } catch (e) {
                    dispatch({
                        type: SET_JOBPOSTING_DATES.FAIL,
                    });
                }
            }
        });
    };
};

export const getDateStringFromMoment = (weekStart, add) => {
    const weekStartMoment = moment(weekStart);

    return weekStartMoment.add(add, "days").format("DD-MM-YYYY").toString();
};

export const setSelectedJobpostingID = (jobpostingID) => {
    return (dispatch) => {
        dispatch({ type: SET_SELECTED_JOBPOSTING_ID, payload: jobpostingID });
    };
};

export const setEventDate = (movingColumnIndex, movingRowIndex) => {
    return (dispatch, getStore) => {
        const store = getStore();
        const clickedEventSegment = selectClickedEventSegment(store);
        const weekCount = selectWeekCount(store);
        const weekStart = selectWeekStart(store);

        if (movingColumnIndex < 0 || movingColumnIndex >= weekCount * 7) {
            return;
        }

        const jobpostings = selectArrangedJobpostingsFromStore(store);

        const eventUid = get(clickedEventSegment, "event.uid") || false;
        const type = get(clickedEventSegment, "type") || false;
        const columnIndex = get(clickedEventSegment, "columnIndex") || false;
        let startDate = false;
        let endDate = false;
        if (jobpostings[eventUid]) {
            switch (type) {
                case "resizeLeft": {
                    jobpostings[eventUid]["startIndex"] = movingColumnIndex;
                    startDate = getDateStringFromMoment(
                        weekStart,
                        movingColumnIndex
                    );
                    break;
                }

                case "resizeRight": {
                    jobpostings[eventUid]["endIndex"] = movingColumnIndex;
                    endDate = getDateStringFromMoment(
                        weekStart,
                        movingColumnIndex
                    );
                    break;
                }
                case "move": {
                    const columnDelta = movingColumnIndex - columnIndex;
                    const initialEventState =
                        get(clickedEventSegment, "event") || false;

                    const newStartIndex =
                        initialEventState.startIndex + columnDelta;
                    let newEndIndex = initialEventState.endIndex + columnDelta;

                    jobpostings[eventUid]["startIndex"] = newStartIndex;
                    jobpostings[eventUid]["endIndex"] = newEndIndex;
                    const width = newEndIndex - newStartIndex;

                    if (width === 0) {
                        newEndIndex = newStartIndex;
                    }
                    startDate = getDateStringFromMoment(
                        weekStart,
                        newStartIndex
                    );
                    endDate = getDateStringFromMoment(weekStart, newEndIndex);

                    break;
                }

                default:
                    break;
            }

            dispatch({ type: SET_ARRANGED_JOBPOSTINGS, payload: jobpostings });
            dispatch(setJobpostingDates(eventUid, startDate, endDate));
        }
    };
};

export const navigateTo = (url) => {
    return (dispatch) => {
        dispatch(push(url));
    };
};

export const getIsLocked = () => {
    return (dispatch) => {
        dispatch({
            type: GET_ROSTER_IS_LOCKED.REQUEST,
        });
        firebase.auth().onAuthStateChanged((user) => {
            if (user === null) {
                dispatch({
                    type: GET_ROSTER_IS_LOCKED.FAIL,
                });
            } else {
                try {
                    firebase
                        .database()
                        .ref(`/dashboard/roster/ui/is_locked`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_ROSTER_IS_LOCKED.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } catch (e) {
                    dispatch({
                        type: GET_ROSTER_IS_LOCKED.FAIL,
                    });
                }
            }
        });
    };
};

export const setIsLocked = (isLocked) => {
    return (dispatch) => {
        dispatch({
            type: SET_ROSTER_IS_LOCKED.REQUEST,
        });
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user === null) {
                dispatch({
                    type: SET_ROSTER_IS_LOCKED.FAIL,
                });
            } else {
                try {
                    await firebase
                        .database()
                        .ref(`/dashboard/roster/ui`)
                        .update({ is_locked: isLocked });
                    dispatch({
                        type: SET_ROSTER_IS_LOCKED.SUCCESS,
                    });
                } catch (e) {
                    dispatch({
                        type: SET_ROSTER_IS_LOCKED.FAIL,
                    });
                }
            }
        });
    };
};
